var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_1345)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    rx: 15,
    fill: "#EEF3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.792 127.812C109.491 128.027 109.147 128.242 108.846 128.457C108.502 128.672 108.201 128.887 107.857 129.059C107.556 129.231 107.298 129.403 106.997 129.575C106.954 129.618 106.911 129.618 106.868 129.661C105.879 130.263 104.847 130.822 103.815 131.338C103.514 131.51 103.17 131.682 102.869 131.811C102.869 131.811 102.826 131.854 102.783 131.854C102.439 132.026 102.095 132.198 101.751 132.37C101.063 132.714 100.332 133.015 99.6441 133.316C99.3001 133.488 98.9131 133.617 98.5691 133.746C98.2251 133.875 97.8381 134.047 97.4941 134.176C97.1501 134.305 96.7631 134.477 96.4191 134.606C96.4191 134.606 96.4191 134.606 96.3761 134.606C96.0321 134.735 95.6451 134.864 95.3011 134.993C94.5271 135.251 93.7101 135.509 92.9361 135.767C92.6781 135.853 92.3771 135.939 92.1191 136.025C91.3021 136.283 90.4851 136.498 89.6681 136.67C89.3671 136.756 89.0661 136.799 88.7221 136.885C87.9481 137.057 87.1311 137.229 86.3571 137.401C86.1851 137.444 86.0561 137.444 85.8841 137.487C85.6261 137.53 85.3251 137.573 85.0671 137.616C84.6801 137.659 84.3361 137.745 83.9491 137.788C83.7771 137.831 83.6051 137.831 83.4331 137.874C83.2181 137.917 82.9601 137.96 82.7021 137.96C82.0141 138.046 81.2831 138.132 80.5951 138.218C80.3801 138.261 80.1221 138.261 79.9071 138.304H79.8641C79.5631 138.347 79.2621 138.347 78.9611 138.39C78.6601 138.433 78.3591 138.433 78.0581 138.433C77.8861 138.433 77.6711 138.476 77.4991 138.476C77.1551 138.476 76.8541 138.519 76.5531 138.519C76.1231 138.519 75.7361 138.562 75.3061 138.562C74.8761 138.562 74.4891 138.562 74.0591 138.562C73.7581 138.562 73.4571 138.562 73.1561 138.562C55.0531 138.304 38.7131 130.607 27.1031 118.395C27.1031 118.395 27.1031 118.352 27.0601 118.352C28.3931 115.729 33.3381 110.999 38.4981 107.086C45.0341 102.141 54.2791 99.0881 54.2791 99.0881C54.2791 99.0881 60.3421 98.0991 82.8311 102.786C99.9881 106.398 107.298 121.061 109.792 127.812Z",
    fill: "#E2B993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6039 114.697C86.7009 119.126 80.8529 121.749 71.0059 117.793C58.9229 112.891 54.2789 99.0882 54.2789 99.0882C53.6339 89.1982 52.1289 80.7272 52.1289 80.7272C66.1039 79.5232 82.6159 95.8632 82.6159 95.8632L84.5079 103.947C84.6799 104.635 85.0239 105.237 85.5399 105.667C86.4429 107.215 88.2059 111.859 87.6039 114.697Z",
    fill: "#E2B993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.54 105.71C77.327 105.28 71.264 104.076 64.771 92.4233C70.275 97.2823 76.768 99.1313 83.605 99.9913L84.508 103.947C84.68 104.678 85.024 105.28 85.54 105.71Z",
    fill: "#E1A46B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.525 53.8952C103.299 57.5072 103.686 60.4312 101.579 70.0632C99.4718 79.6952 103.514 89.3272 93.3658 98.1422C86.5288 104.076 74.5748 105.194 65.0288 98.7012C61.8038 96.5082 58.8368 93.4552 56.4288 89.4562C54.5368 86.3172 52.3438 83.3502 49.8928 80.6412C46.4958 76.9432 42.4108 69.5042 44.4318 56.3462C47.6998 34.9322 68.8988 32.4812 81.4118 34.8462C93.9248 37.2112 100.418 44.3492 102.525 53.8952Z",
    fill: "#E2B993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3742 70.7082C61.3742 70.7082 60.0412 64.2583 53.7632 65.0323C48.3452 65.7203 46.4532 78.7062 58.7512 82.3182",
    fill: "#E2B993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3637 76.4271C58.3637 76.4271 56.8157 75.4381 56.9877 73.7181C57.2457 71.6971 56.9877 70.4501 56.0417 70.0631C53.6767 69.0741 53.2037 71.8261 53.2897 72.1701",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1731 80.5981C91.1731 80.5981 92.8071 80.6841 94.3551 78.8351C95.2151 77.8031 95.9461 76.5131 95.4731 76.1261C95.0001 75.6961 87.2171 76.9001 86.7011 77.9321C86.1851 78.9641 89.1951 80.5981 91.1731 80.5981Z",
    fill: "#E1A46B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4632 66.1501C92.4632 66.1501 92.5492 70.2351 95.1722 74.7931C96.3332 76.8141 94.5702 80.1251 90.7432 80.6841",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M69.157 82.7912C71.6031 82.7912 73.586 81.1548 73.586 79.1362C73.586 77.1176 71.6031 75.4812 69.157 75.4812C66.711 75.4812 64.728 77.1176 64.728 79.1362C64.728 81.1548 66.711 82.7912 69.157 82.7912Z",
    fill: "#F7DABF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M100.891 75.5671C100.762 77.9751 100.805 80.3401 100.633 82.7051C98.7407 82.2751 97.3647 80.8561 97.3647 79.1791C97.3647 77.3731 98.8697 75.9111 100.891 75.5671Z",
    fill: "#F7DABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.001 154.421H15.2974C15.2974 154.421 15.9424 134.469 22.4784 120.236C27.4234 109.486 39.0764 103.509 47.7624 100.413C50.2134 99.5533 52.4494 98.9083 54.1694 98.4353C54.1694 98.6503 54.2124 98.8223 54.2124 99.0373C54.2124 99.0373 58.8564 112.84 70.9394 117.742C80.7864 121.741 86.6344 119.075 87.5374 114.646C88.0964 111.808 86.3334 107.164 85.4304 105.659C84.9144 105.229 84.5704 104.584 84.3984 103.939L84.0544 102.52C84.8714 102.348 85.6454 102.133 86.4194 101.875C86.6774 101.789 86.8924 101.703 87.1504 101.617C92.6974 103.079 101.039 106.562 110.886 114.818C122.023 124.106 124.001 154.421 124.001 154.421Z",
    fill: "#F3C2C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1986 122.214C52.3636 115.549 46.6016 103.638 47.7196 100.413C47.7196 100.413 47.7196 100.37 47.7626 100.327C48.5366 98.7364 49.7836 97.4464 51.3316 96.5434C52.1916 96.0274 53.1376 95.5544 53.9116 95.2964C53.9546 95.8984 54.1266 97.7904 54.1696 98.4354C54.1696 98.6504 54.2126 98.8224 54.2126 99.0374C54.2126 99.0374 56.9646 109.314 69.0476 114.216C78.8946 118.215 85.0006 115.592 85.6456 111.12C86.3766 106.175 83.5816 102.606 83.5816 102.606C84.3986 102.434 85.6886 102.133 86.4626 101.875C88.3546 104.154 90.2896 106.433 91.0206 112.453C92.0526 121.096 82.5496 129.137 67.1986 122.214Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5825 154.421L34.6475 138.469",
    stroke: "#9F6A6A",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.66 133.051C111.66 133.051 110.37 136.19 110.757 139.329C111.144 142.468 112.262 147.069 110.671 154.422",
    stroke: "#9F6A6A",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8681 70.4673C75.8361 70.4243 75.0621 69.5643 75.1481 68.5323L75.1911 67.3283C75.2341 66.2963 76.0941 65.5223 77.1261 65.6083C78.1581 65.6513 78.9321 66.5113 78.8461 67.5433L78.8031 68.7473C78.7601 69.7363 77.9001 70.5103 76.8681 70.4673Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9712 71.1123C94.0252 71.0693 93.2943 70.2523 93.3373 69.3063L93.3803 68.1883C93.4233 67.2423 94.2402 66.5113 95.1862 66.5543C96.1322 66.5973 96.8633 67.4143 96.8203 68.3603L96.7773 69.4783C96.7343 70.4243 95.9172 71.1553 94.9712 71.1123Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.039 67.9733C81.039 67.9733 79.921 66.3823 77.986 66.0813C76.395 65.8233 74.632 66.5973 74.374 67.5003",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7241 68.3606C93.7241 68.3606 93.7241 66.9846 95.7021 66.9846C97.3361 66.9846 98.0241 68.4896 98.0241 68.4896",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8024 61.0504C83.7054 61.3514 84.6084 60.5344 84.4364 59.5454C84.3504 59.0294 84.1354 58.5134 83.7054 58.1264C82.4154 56.9654 77.0834 55.9334 73.8584 57.4384C71.0204 58.8144 78.6744 59.6744 82.8024 61.0504Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6592 61.7385C94.9282 61.9965 94.1542 61.2225 94.2832 60.3195C94.3262 59.8465 94.4982 59.3735 94.8422 59.0295C95.8742 57.9975 99.4002 57.1805 101.636 58.7715C103.571 60.1045 99.0132 60.4915 95.6592 61.7385Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3858 85.591C88.4288 86.279 87.9128 87.483 86.9668 88.343C82.1078 85.376 79.9148 86.924 79.9148 86.924C78.1948 84.301 78.5818 80.732 82.7528 83.441C85.6768 85.29 87.4398 85.591 88.3858 85.591Z",
    fill: "#423232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.967 88.3431C85.935 89.2461 84.387 89.8052 82.28 88.9452C81.291 88.5582 80.517 87.7842 79.915 86.9242C79.915 86.9242 82.108 85.3761 86.967 88.3431Z",
    fill: "#FE9DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2034 85.4191C89.2034 85.4191 87.3974 86.4081 82.7534 83.4411C77.2064 79.8721 78.3244 87.3541 82.2374 88.9451C86.3224 90.6221 88.4294 86.967 88.3864 85.5911",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.915 86.9242C79.915 86.9242 82.108 85.3761 86.967 88.3431",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.985 56.7552C106.781 60.4962 104.158 63.9792 102.309 66.0432C103.47 59.5072 103.126 56.9272 102.438 53.8742C102.223 52.9282 101.965 52.0252 101.664 51.1222C94.9134 57.7012 83.3464 51.2082 83.3464 51.2082C83.3464 51.2082 80.8954 53.2292 76.5954 52.7562C71.9944 52.2832 70.7474 49.4452 70.7474 49.4452C69.5004 58.1312 61.2874 54.8202 62.7924 63.4632C63.2224 65.8282 63.2224 68.1072 61.2014 70.4722C60.8574 69.2682 59.1804 64.3662 53.6764 65.0542C48.4734 65.6992 46.4954 77.7392 57.2454 81.8672C57.1164 85.8662 50.7524 95.8852 50.9674 84.7052C51.0104 82.4262 44.4744 82.5982 40.9054 75.0732C39.3574 71.8052 39.7874 68.7522 40.4754 66.5592C41.1634 64.4522 41.1204 62.1732 40.4324 60.0662C39.6584 57.6152 39.0564 53.9172 40.4754 49.4452C42.8834 41.7912 48.0434 40.0282 49.3764 39.1252C50.7094 38.2222 50.2794 31.6002 61.5884 27.9022C68.8984 25.4942 76.7244 29.6652 78.3584 29.3642C79.9924 29.0632 91.4304 21.5382 100.245 28.6332C108.759 35.5132 105.577 43.6402 105.577 43.6402C105.577 43.6402 110.909 47.7252 107.985 56.7552Z",
    fill: "#543737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3471 75.3919H73.3281C70.7051 75.3919 68.5981 73.2849 68.5981 70.6619V66.5769C68.5981 63.9539 70.7051 61.8469 73.3281 61.8469H83.3471C85.9701 61.8469 88.0771 63.9539 88.0771 66.5769V70.6619C88.0771 73.2849 85.9271 75.3919 83.3471 75.3919Z",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.633 61.8469H95.6878C93.9678 61.8469 92.5488 63.2659 92.5488 64.9859V68.7269C93.1508 70.8769 94.0108 72.9409 95.3008 74.7899C95.4298 74.7899 95.5588 74.8329 95.6878 74.8329H100.633C102.353 74.8329 103.772 73.4139 103.772 71.6939V64.9859C103.815 63.2229 102.396 61.8469 100.633 61.8469Z",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0767 65.76C89.5387 65.588 91.3877 65.459 92.9357 65.631",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5981 66.061L58.6221 66.405",
    stroke: "#423232",
    strokeWidth: 1.29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3603 130H43.1471C29.2587 130 18 118.725 18 104.818V82.1533M65.3603 15H43.1471C29.2587 15 18 26.2746 18 40.1825V62.8467M84.6397 130H106.853C120.741 130 132 118.725 132 104.818V82.1533M84.6397 15H106.853C120.741 15 132 26.2746 132 40.1825V62.8467",
    stroke: "#BBC1C9",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_1345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    rx: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarImage);
export default __webpack_public_path__ + "static/media/AvatarImage.09fd43f9221d7dae112525fae795dbb6.svg";
export { ForwardRef as ReactComponent };